var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('NavBar'),_c('div',{staticClass:"app-main"},[_c('router-view')],1),_c('Footer'),_c('el-backtop',{staticClass:"site-backtop",attrs:{"bottom":100,"right":40}},[_c('i',{staticClass:"el-icon-top"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }